import { useState } from 'react'
import { Check, Copy } from 'lucide-react'

import { Button } from '@components/ui/button'

const CopyToClipboardButton = ({ label, value, className }) => {
  const [codeCopied, setCodeCopied] = useState(false)

  const copyToClipboard = () => {
    navigator.clipboard.writeText(value)
  }

  return (
    <Button
      variant='outline'
      className={className}
      aria-label='Copy to clipboard'
      type='button'
      onClick={() => {
        copyToClipboard()
        setCodeCopied(true)
        setTimeout(() => setCodeCopied(false), 1000)
      }}
    >
      <span className='mr-3'>
        {label}
      </span>

      <Choose>
        <When condition={codeCopied}>
          <Check size={16} />
        </When>

        <Otherwise>
          <Copy size={16} />
        </Otherwise>
      </Choose>
    </Button>
  )
}

export default CopyToClipboardButton
